import { TThunkAction } from '../../../../common/types/thunk';

import { selectIsPromotionPackageSelected } from '../../../selectors/publishTerms';
import { selectIsAuctionSelected } from '../../../selectors/auction';
import { changeCurrentOverPackageBet, changeCurrentOverServiceBet } from '../../../actions/auction';
import { reloadBetPosition } from '../../../actions/betPosition';
import { checkServiceAfterChangeBet } from '../../../actions/checkoutInfo';

import { TChangeCurrentBetSource } from './types';

interface IParams {
  source?: TChangeCurrentBetSource;
  afterCheckService?: boolean;
  bet: number;
}

export const changeCurrentBet =
  ({ afterCheckService, bet, source }: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
    const isAuctionSelected = selectIsAuctionSelected(state);

    if (isPromotionPackageSelected) {
      dispatch(changeCurrentOverPackageBet(bet));
    } else if (isAuctionSelected) {
      dispatch(changeCurrentOverServiceBet(bet));
    }

    dispatch(reloadBetPosition());

    if (!afterCheckService && source) {
      dispatch(checkServiceAfterChangeBet(source));
    }
  };
